import * as runtime from '@/api/runtime'
import {
  BatchSchoolUserListRequest,
  BatchSchoolUserListRequestToJSON,
  BatchStatisticsPageLoadRequest,
  BatchStatisticsPageLoadRequestToJSON
} from '@/api/models/batch'
import {
  BatchSchoolUserListCondition,
  BatchSchoolUserListConditionFromJSON
} from '@/api/models/batch/BatchSchoolUserListCondition'

/**
 * 帳票作成
 */
export class BatchSchoolUserListApi extends runtime.BaseAPI {
  async return(request: BatchSchoolUserListRequest): Promise<number> {
    const response = await this.requestPost(
      `/batch/school-user-management/user-list`,
      BatchSchoolUserListRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }

  async getInitialCondition(
    request: BatchStatisticsPageLoadRequest
  ): Promise<BatchSchoolUserListCondition> {
    const response = await this.requestGet(
      `/batch/statistics/search_initial_condition`,
      BatchStatisticsPageLoadRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchSchoolUserListConditionFromJSON(jsonValue)
    ).value()
  }
}
